import beTwMerge from '@/utils/beTwMerge';

export default function HeaderButtons({
  activePageNames,
  info,
  activePage,
  onClose,
  setInfo,
}: {
  activePageNames: { [key: number]: string };
  info: any;
  setInfo: (key: string, value: any) => void;
  activePage: number;
  onClose: () => void;
}) {
  return (
    <div
      className={beTwMerge(
        'tw-h-9 lg:tw-h-10 tw-w-full tw-bg-color-dark-green tw-flex tw-justify-between tw-px-4',
        (activePage === 1 || activePage === 5) && 'tw-justify-end'
      )}
    >
      {activePage > 1 && activePage < 5 && (
        <button
          type="button"
          className="close !tw-static tw-h-full tw-flex tw-items-center tw-opacity-100 hover:tw-opacity-100 tw-w-fit"
          style={{ textShadow: 'none' }}
          data-dismiss="modal"
          aria-label="Go to previous page"
          onClick={() => {
            (window as any).dataLayer.push({
              event: 'appointment_form',
              showroom_page_section: activePageNames[activePage],
              showroom_action: 'previous',
              showroom_location: info.selectedShowroomStore.modalName,
              general_event_details: 'Undefined',
            });
            setInfo('activePage', activePage - 1);
          }}
        >
          <svg
            width="23"
            height="12"
            viewBox="0 0 23 12"
            fill="none"
            className="tw-text-white tw-fill-white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.469669 5.66086C0.176777 5.95376 0.176777 6.42863 0.469669 6.72152L5.24264 11.4945C5.53553 11.7874 6.01041 11.7874 6.3033 11.4945C6.59619 11.2016 6.59619 10.7267 6.3033 10.4338L2.06066 6.19119L6.3033 1.94855C6.59619 1.65566 6.59619 1.18079 6.3033 0.887892C6.01041 0.594998 5.53553 0.594998 5.24264 0.887892L0.469669 5.66086ZM23 5.44119L1 5.44119V6.94119L23 6.94119V5.44119Z"
              fill="white"
            />
          </svg>

          <span className="sr-only">go back</span>
        </button>
      )}
      <button
        type="button"
        className="close !tw-static tw-h-full tw-flex tw-justify-end tw-items-center tw-opacity-100"
        aria-label="Close"
        onClick={() => {
          (window as any).dataLayer.push({
            event: 'appointment_form',
            showroom_page_section: activePageNames[activePage],
            showroom_action: 'close pop-up|x close',
            showroom_location: info.selectedShowroomStore.modalName,
            general_event_details: 'Undefined',
          });
          onClose();
        }}
        style={{ textShadow: 'none' }}
        data-dismiss="modal"
      >
        <i className="iconfont iconfont-close2 tw-text-sm tw-opacity-100 [&::before]:tw-text-white" />
        <span className="sr-only">close</span>
      </button>
    </div>
  );
}
